/**
 * English for the report engine (card У5): «Отчёты», a campaign's «Отчёт»,
 * a lander's «Цифры». Spread into `en`, so the keys are part of `TKey` and
 * `ru.reports.ts` must cover every one of them.
 */
export const enReports = {
  "period.cmp.custom": "a range of my own",
  "period.from": "From",
  "period.to": "To",
  "period.cmpFrom": "Compare from",
  "period.cmpTo": "Compare to",
  "period.legend.period": "period",
  "period.legend.compare": "comparison",
  "period.todaySuffix": "today",
  "period.note": "day by {tz} · changed in Settings",
  "rep.title": "Report",
  "rep.views": "Reports",
  "rep.view.ads": "By ad",
  "rep.view.time": "By geo and hour",
  "rep.view.landers": "Landers",
  "rep.view.offers": "Offers by network",
  "rep.views.more": "{n} more",
  "rep.views.moreAria": "{n} more reports",
  "rep.views.chip": "Report «{name}»",
  "rep.views.chipShared": "Report «{name}», shared",
  "rep.views.delete": "Delete report «{name}»",
  "rep.views.createAria": "Save the current report as a view",
  "rep.views.deleted": "Report «{name}» deleted",
  "rep.views.save": "Save view",
  "rep.views.all": "All reports",
  "rep.views.find": "Find a report",
  "rep.views.builtin": "Built-in",
  "rep.views.saved": "Saved",
  "rep.views.workspace": "Workspace",
  "rep.views.unknownAuthor": "someone",
  "rep.views.mine": "mine",
  "rep.views.copyLink": "Copy the link to «{name}»",
  "rep.views.actions": "Actions with «{name}»",
  "rep.save": "Save",
  "rep.saved": "Report «{name}» saved",
  "rep.saveFailed": "Could not save",
  "rep.link": "Link",
  "rep.linkCopied": "Link to the report copied",
  "rep.csvEmpty": "The report has no rows",
  "rep.cancel": "Cancel",
  "rep.close": "Close",
  "rep.loading": "Counting…",
  "rep.nothingFound": "Nothing found",
  "rep.naming": "Loading the name…",
  "rep.fold.chosen": "{chosen} of {total}",
  "rep.fold.collapse": "{name} — collapse",
  "rep.fold.expand": "{name} — expand",
  "rep.error": "Could not build the report",
  "rep.grouping": "Grouping",
  "rep.level.add": "+ level",
  "rep.level.search": "Find a dimension or a sub label",
  "rep.level.keys": "↑↓ select · ↵ add level",
  "rep.level.order": "Order of levels — drag:",
  "rep.level.n": "level {n}",
  "rep.level.count": "{n} of {max}",
  "rep.level.remove": "Remove level «{name}»",
  "rep.level.move": "Move «{name}» — drag, or Alt+←/→",
  "rep.group.source": "Source",
  "rep.group.path": "Campaign",
  "rep.group.campaign": "Campaign",
  "rep.group.ad": "Ad",
  "rep.group.funnel": "Funnel",
  "rep.group.labels": "Labels",
  "rep.group.geo": "Geo",
  "rep.group.device": "Device",
  "rep.group.network": "Network",
  "rep.group.time": "Time",
  "rep.group.conversion": "Conversion",
  "rep.group.quality": "Quality",
  "rep.basis": "Conversions by",
  "rep.basis.lead": "lead date",
  "rep.basis.conv": "conversion date",
  "rep.basis.click": "click date",
  "rep.compare": "Compare",
  "rep.compare.short": "Compare",
  "rep.compare.against": "against",
  "rep.compare.prev": "previous period",
  "rep.compare.year": "a year ago",
  "rep.compare.view": "How to show the comparison",
  "rep.compare.side": "Side by side",
  "rep.compare.delta": "Δ only",
  "rep.compare.sortedBy": "sorted by «{metric}»",
  "rep.compare.live": "{day} is still running",
  "rep.was": "was {value}",
  "rep.prevValue": "was {value}",
  "rep.filters": "Filters",
  "rep.filters.reset": "Reset all",
  "rep.pinned": "pinned",
  "rep.pinned.hint": "The report is opened from here — this filter stays",
  "rep.filter": "Filter",
  "rep.filter.dims": "Dimensions",
  "rep.filter.metrics": "Metrics",
  "rep.filter.byMetric": "Condition on a metric",
  "rep.filter.metric": "Metric",
  "rep.filter.op": "Operator",
  "rep.filter.value": "Value",
  "rep.filter.removeCondition": "Remove the condition",
  "rep.filter.addCondition": "condition",
  "rep.filter.where": "Metric conditions are tested on every row of the report, dimensions before grouping.",
  "rep.filter.in": "is in",
  "rep.filter.notInLong": "is not in",
  "rep.filter.notIn": "not",
  "rep.filter.contains": "contains",
  "rep.filter.notContains": "does not contain",
  "rep.filter.find": "Find: {what}",
  "rep.filter.valuesNote": "The number on the right is the period's clicks. {n} picked.",
  "rep.filter.found": "Found {what}",
  "rep.filter.reset": "Reset",
  "rep.filter.apply": "Apply",
  "rep.band.traffic": "Traffic",
  "rep.band.conversions": "Conversions",
  "rep.band.money": "Money",
  "rep.band.custom": "Own",
  "rep.band.collapse": "collapse",
  "rep.band.expand": "expand",
  "rep.band.running": "running",
  "rep.band.series": "What by day",
  "rep.band.roi": "ROI",
  "rep.band.vsPrev": "against the previous {n}",
  "rep.band.this": "this period",
  "rep.band.prev": "the previous {n} days",
  "rep.series.profit": "Profit by day",
  "rep.series.leads": "Leads by day",
  "rep.series.cr": "CR by day",
  "rep.series.clicks": "Clicks by day",
  "rep.series.short.profit": "Profit",
  "rep.series.short.leads": "Leads",
  "rep.series.short.cr": "CR",
  "rep.series.short.clicks": "Clicks",
  "rep.col.payout": "Payout",
  "rep.col.roi": "ROI",
  "rep.col.landerCr": "CR after the lander",
  "rep.col.landerEpc": "Revenue per lander visit",
  "rep.total": "Total, {what}",
  "rep.total.short": "Total",
  "rep.total.csv": "Total",
  "rep.columns": "Columns: {set}",
  "rep.columns.title": "Columns",
  "rep.columns.description": "Which numbers the report shows",
  "rep.columns.sets": "Set",
  "rep.columns.save": "Save as a set",
  "rep.columns.reset": "Reset",
  "rep.columns.empty": "Nothing to choose from",
  "rep.columns.caption": "Set:",
  "rep.columns.search": "Find a metric",
  "rep.columns.clearSearch": "Clear search",
  "rep.columns.noMatches": "No metric “{query}”",
  "rep.columns.count": "{shown} of {total}",
  "rep.set.money": "Money",
  "rep.set.funnel": "Funnel",
  "rep.set.quality": "Traffic quality",
  "rep.set.compare": "Comparison",
  "rep.set.own": "own",
  "rep.set.mine": "My columns",
  "rep.set.mineChip": "Mine",
  "rep.band.goals": "Goals",
  "rep.set.saved": "Set «{name}» saved",
  "rep.formula.add": "Own formula",
  "rep.formula.title": "Own metric",
  "rep.formula.editTitle": "Change the metric",
  "rep.formula.body": "It appears in the columns of every report and of the campaign list of this workspace.",
  "rep.formula.name": "Name",
  "rep.formula.namePlaceholder": "For example: Profit per lead",
  "rep.formula.formula": "Formula",
  "rep.formula.placeholder": "Type a metric or press it below",
  "rep.formula.palette": "Insert into the formula",
  "rep.formula.unit": "Format",
  "rep.formula.unit.number": "Number",
  "rep.formula.unit.money": "Money",
  "rep.formula.decimals": "Decimal places",
  "rep.formula.better": "Better when",
  "rep.formula.better.higher": "higher",
  "rep.formula.better.lower": "lower",
  "rep.formula.check": "Checked on the open report",
  "rep.formula.checkOver": "total · {text}",
  "rep.formula.zero": "A division by zero shows as «—».",
  "rep.formula.create": "Add the metric",
  "rep.formula.save": "Save",
  "rep.formula.delete": "Delete",
  "rep.formula.created": "Metric «{name}» added",
  "rep.formula.updated": "Metric «{name}» saved",
  "rep.formula.deleted": "Metric «{name}» deleted",
  "rep.formula.error.empty": "The formula is empty",
  "rep.formula.error.unbalanced": "The brackets do not match",
  "rep.formula.error.incomplete": "The formula is not finished",
  "rep.formula.error.unknown-metric": "The formula has a metric that is gone",
  "rep.save.title": "Save the report",
  "rep.save.body": "The report appears beside «By ad» and opens from a link.",
  "rep.save.name": "Name",
  "rep.save.placeholder": "For example: Nutra RO · by ad",
  "rep.save.what": "What is saved",
  "rep.save.columns": "Columns",
  "rep.save.columns.set": "set «{set}», {n} columns",
  "rep.save.columns.own": "own, {n} columns",
  "rep.save.noFilters": "no filters",
  "rep.save.comparePrev": "compared with the previous period",
  "rep.save.compareYear": "compared with a year ago",
  "rep.save.keepPeriod": "Keep the period {period}",
  "rep.save.keepPeriod.else": "otherwise — the Top bar's period",
  "rep.save.shared": "Seen by everybody in {workspace}",
  "rep.save.shared.hint": "Others open and copy it, only you change it",
  "rep.save.nameTaken": "Name taken? We add «(2)»",
  "rep.save.submit": "Save",
  "rep.empty.filtered": "No rows under these filters",
  "rep.empty.filtered.one": "No rows for {period} where {where}. Remove this condition or widen the period.",
  "rep.empty.filtered.many": "No rows for {period} where {where}. Remove «{last}» or widen the period.",
  "rep.empty.and": "and",
  "rep.empty.period": "No rows for the period",
  "rep.empty.period.body": "No clicks or conversions for {period}. Empty is not broken: the health line below shows clicks and postbacks arriving.",
  "rep.empty.30d": "30 days",
  "rep.empty.reset": "Reset filters",
  "rep.empty.noCampaigns": "No campaigns",
  "rep.empty.noCampaigns.body": "The report counts the list's campaigns — create the first one.",
  "rep.foot.rows": "{groups} groups on every level · {top}",
  "rep.foot.truncated": "the first {shown} are shown — narrow with a filter or drop a level",
  "rep.foot.loading": "Building the report… usually under 2 s; old rows stay dimmed while the grouping changes",
  "rep.foot.empty": "Empty is not broken: the health line below shows clicks and postbacks arriving",
  "rep.foot.legend": "clicks = people, bots filtered out · money in USD at the conversion day's rate",
  "rep.lander.type": "Kind",
  "rep.lander.all": "All",
  "rep.lander.landings": "Landers",
  "rep.lander.prelandings": "Prelanders",
  "rep.lander.typeNote": "White pages and «Thank you» pages are not shown: they have no LP click",
  "rep.lander.crNote": "CR after the lander = leads / LP clicks",
  "rep.lander.landing": "Lander",
  "rep.lander.prelanding": "Prelander",
  "rep.lander.vsl": "VSL",
  "rep.lander.danger": "Danger",
  "rep.offer.paused": "Paused",
  "rep.offer.capped": "Capped today",
  "rep.time.title.profit": "Profit by weekday and hour",
  "rep.time.title.cr": "CR by weekday and hour",
  "rep.time.title.leads": "Leads by weekday and hour",
  "rep.time.title.clicks": "Clicks by weekday and hour",
  "rep.time.measure": "What the cell shows",
  "rep.time.country": "Country",
  "rep.time.allCountries": "All countries",
  "rep.time.noData": "no data",
  "rep.time.loss": "loss",
  "rep.time.gain": "profit · per hour, USD over {days} days",
  "rep.time.tip.sub": "over {days} days, every campaign",
  "rep.time.byDay": "By day",
  "rep.time.readings": "What it shows",
  "rep.time.readings.none": "Nothing to read yet: no spend or revenue in the period.",
  "rep.time.worst": "Worst hours: {from}–{to}",
  "rep.time.worst.sub": "minus {loss} USD over {days} days, CR {cr} against {avg} on average",
  "rep.time.best": "Best: {from}–{to}",
  "rep.time.best.day": "Best: {from}–{to}, {day} most of all",
  "rep.time.best.sub": "{share} of the period's profit in {hours} of the hours",
  "rep.time.weekend.weaker": "Weekends are {pct} weaker",
  "rep.time.weekend.stronger": "Weekends are {pct} stronger",
  "rep.time.weekend.sub": "CR {cr} against {avg} on weekdays",
  "rep.time.schedule": "Ad schedule",
  "rep.time.zone": "account time zone: {tz}",
  "rep.time.allDay": "all day",
  "rep.time.copy": "Copy for Facebook",
  "rep.time.copied": "Schedule copied",
  "rep.time.saves": "saves ≈ {usd} USD a week",
  "rep.time.nothingToCut": "no losing hours — run all day",
  "rep.time.byCountry": "By country",
  "rep.time.col.country": "Country",
  "rep.wd.1": "Monday",
  "rep.wd.2": "Tuesday",
  "rep.wd.3": "Wednesday",
  "rep.wd.4": "Thursday",
  "rep.wd.5": "Friday",
  "rep.wd.6": "Saturday",
  "rep.wd.7": "Sunday",
  "dimNone.owner": "No buyer",
  "dimWord.owner": "buyer|buyers|buyers",
  "origin.native": "Tracker",
  "origin.imported": "Import",
  "dimNone.entry_point": "No entry point",
  "dimWord.entry_point": "entry point|entry points|entry points",
  "entryMatch.queryKey": "Key in the link",
  "entryMatch.queryValue": "Parameter value",
  "entryMatch.sticky": "Returned (cookie)",
  "entryMatch.fallback": "Fallback",
  "entryMatch.rule": "Rule {n}",
  "rep.card.openInReports": "Open in Reports",
  "rep.card.saveAsReport": "Save as a report",
  "rep.card.note": "One report engine: the same report as in «Reports», pinned to this campaign",
  "rep.card.campaign": "this one",
} as const;
